import React, { useEffect, useState } from "react";
import {
	IonGrid,
	IonRow,
	IonCol,
	IonText,
	IonButton,
	IonImg,
	IonLabel,
	isPlatform,
} from "@ionic/react";

import "./offers.scss";
import * as constants from "../../../constants";
import moment from "moment";
import { connect } from "react-redux";
import { getOffersData } from "../../../Store/Actions";
import ScreenBanner from "../../../utils/screenBanner";
import { SocialSharing } from "@ionic-native/social-sharing";
import { ToastMessage } from "../../../utils/toastMessage";
import { checkMediaQuery } from "../../../utils";

const Offers: React.FC = (props: any) => {
	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	useEffect(() => {
		// props.getOffersData();
	}, []);

	const ExpiredOffers = (props.offersData || []).filter(
		(offer: any, ind: any) => new Date(offer.validity.endDate) < new Date()
	);
	const NewlyAddedOffers = (props.offersData || []).filter((offer: any, ind: any) => {
		const todayDate = new Date();
		const tenDaysAgoTimeStamp = todayDate.setDate(todayDate.getDate() - 10);
		if (
			new Date(tenDaysAgoTimeStamp) < new Date(offer.validity.startDate) &&
			new Date(offer.validity.startDate) < new Date()
		) {
			return offer;
		}
	});

	const otherOffers = (props.offersData || []).filter((offer: any, ind: any) => {
		if (
			!NewlyAddedOffers.map((ele: any) => ele.offerId).includes(offer.offerId) &&
			!ExpiredOffers.map((ele: any) => ele.offerId).includes(offer.offerId)
		) {
			return offer;
		}
	});
	const onHandleShare = () => {
		if (isPlatform("desktop")) {
			window.navigator.clipboard.writeText(
				`Use my referral code ${props.referalDetails[0].code} ${constants.DYNAMIC_LINK}`
			);
			setToast({
				showToast: true,
				toastMessage: "Referral code copied to clipboard",
				severity: "warning",
			});
		} else {
			SocialSharing.share(
				`Use my referral code ${props.referalDetails[0].code} ${constants.DYNAMIC_LINK}`
			)
				.then(() => {
					console.error("Accepted");
				})
				.catch(() => {
					console.error("Failed");
				});
		}
	};

	return (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
			{isPlatform("ios") && <div className="ios_statusbar_color" />}
			<div className="personal_details_text offers_page offer_header">
				<div
					className="personal_details_div_child wholeApp offersFixedHeader"
					style={{
						paddingTop: isPlatform("android") ? 20 : 0,
					}}
				>
					<IonImg
						src={
							checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"
						}
						className="back_arrow"
						onClick={() => props.history.goBack()}
					/>
					<IonLabel className="personal_details_labels" color="secondary">
						{constants.OFFERS}
					</IonLabel>
					<div />
				</div>
			</div>
			<div className="off_marginTop90">
				{Boolean(NewlyAddedOffers.length) && (
					<>
						<div className="newly_added">
							<IonLabel>{constants.NEWLY_ADDED}</IonLabel>
						</div>
						{NewlyAddedOffers.map((newOffer: any, ind: any) => (
							<div
								className="offer_layout"
								style={{
									background: `linear-gradient(93.91deg, ${newOffer.displayColor} 1.09%, #231b05 64.95%)`,
								}}
								onClick={() =>
									props.history.push({
										pathname: "/portal/offer-details",
										state: { offerDetails: newOffer, isExpired: false },
									})
								}
							>
								<IonRow className="discount_row ">
									{!!newOffer.name && (
										<>
											<IonCol className="vocher_code" size-md="6" size="7">
												<div className="discount_div">
													<div className="discount_div discount_web">
														{newOffer.name.split(" ").map((name: any, index: any) => (
															<IonLabel
																className={
																	index === 1 ? "discount_value" : "discount_percentage"
																}
																key={index}
																color="secondary"
															>
																{index === 2 ? "Discount" : name}
															</IonLabel>
														))}
													</div>
												</div>
												<div className="border_code" style={{ width: "175px" }}>
													<IonLabel className="year" style={{ paddingLeft: "25px" }}>
														{constants.USE_CODE}
														{newOffer.offerCode}
													</IonLabel>
												</div>
												<IonLabel className="discount_date">
													{constants.VALID}
													<span className="date">
														{moment(newOffer.validity.endDate).format("DD MMM YYYY")}
													</span>
												</IonLabel>
											</IonCol>
											<IonCol className="image_panel" size-md="6" size="5">
												<div className="img_scroll">
													<IonImg
														// src="/images/offer_icon.svg"
														src={newOffer.imageUrl}
														className="discount_slides"
													/>
												</div>
											</IonCol>
										</>
									)}

									{!newOffer.name && (
										<IonCol className="image_panel" size-md="12" size="12">
											<div className="img_scroll">
												<IonImg src={newOffer.imageUrl} />
											</div>
										</IonCol>
									)}
								</IonRow>
							</div>
						))}
					</>
				)}
				{Boolean(otherOffers.length) && (
					<>
						<div className="newly_added">
							<IonLabel>{constants.OFFERS}</IonLabel>
						</div>
						{otherOffers.map((newOffer: any, ind: any) => (
							<div
								className="offer_layout"
								style={{
									background: `linear-gradient(93.91deg, ${newOffer.displayColor} 1.09%, #231b05 64.95%)`,
								}}
								onClick={() =>
									props.history.push({
										pathname: "/portal/offer-details",
										state: { offerDetails: newOffer, isExpired: false },
									})
								}
							>
								<IonRow className="discount_row cursor_pointer_style">
									{!!newOffer.name && (
										<>
											<IonCol className="vocher_code" size-md="6" size="7">
												<div className="discount_div">
													<div className="discount_div discount_web">
														{newOffer.name.split(" ").map((name: any, index: any) => (
															<IonLabel
																className={
																	index === 1 ? "discount_value" : "discount_percentage"
																}
																key={index}
																color="secondary"
															>
																{index === 2 ? "Discount" : name}
															</IonLabel>
														))}
													</div>
												</div>
												<div className="border_code expired_border use_code_center transparentColor">
													<IonLabel className="year use_code_text">
														{constants.USE_CODE}
														{newOffer.offerCode}
													</IonLabel>
												</div>
												<IonLabel className="discount_date">
													{constants.VALID}
													<span className="date">
														{moment(newOffer.validity.endDate).format("DD MMM YYYY")}
													</span>
												</IonLabel>
											</IonCol>
											<IonCol className="image_panel" size-md="6" size="5">
												<div className="img_scroll">
													<IonImg
														// src="/images/offer_icon.svg"
														src={newOffer.imageUrl}
														className="discount_slides"
													/>
												</div>
											</IonCol>
										</>
									)}

									{!newOffer.name && (
										<IonCol className="image_panel" size-md="12" size="12">
											<div className="img_scroll">
												<IonImg src={newOffer.imageUrl} />
											</div>
										</IonCol>
									)}
								</IonRow>
							</div>
						))}
					</>
				)}
				{/* <div className="offer_layout save_discount">
        <IonRow className="discount_row">
          <IonCol className="vocher_code" size-md="6" size="7">
            <div className="discount_div">
              <IonLabel className="discount_percentage" color="secondary">
                {constants.SAVE_UP_TO}{" "}
                <span className="discount_value">30%</span>{" "}
              </IonLabel>
            </div>
            <div className="maintance">
              <IonLabel>On Periodic Car Maintenance</IonLabel>
            </div>
            <div className="learn_more">
              <IonLabel className="learn_more_text">
                {constants.LEARN_MORE}{" "}
              </IonLabel>
              <IonImg src="/images/learn_more.svg" />
            </div>
          </IonCol>
          <IonCol className="image_panel" size-md="6" size="5">
            <div className="img_scroll">
              <IonImg src="/images/save_upto.svg" className="discount_slides" />
            </div>
          </IonCol>
        </IonRow>
      </div> */}
				{/* // ! Uncomment below code when we have the referal details */}
				{/* {!!(props.referalDetails || []).length && (
          <div className="refer_earn_main_wrapper">
            <div className="refer_earn">
              <IonLabel>{constants.REFER_AND_EARN}</IonLabel>
            </div>
            <div
              className="offer_layout refer_and_earn"
              onClick={() => {
                props.history.push("/portal/refer-earn");
              }}
            >
              <IonRow className="discount_row cursor_pointer_style">
                <IonCol className="vocher_code" size-md="6" size="7">
                  <div className="discount_div res_refer">
                    <IonLabel className="discount_percentage" color="secondary">
                      {` Refer & Earn ${props.referalDetails[0].referralPoint} Points`}
                    </IonLabel>
                  </div>
                  <div className="refer-and-earn your_code">
                    <IonLabel className="code_refer">
                      Your code {props.referalDetails[0].code}
                    </IonLabel>
                    <IonImg
                      src="/images/share_icon.svg"
                      className="share_icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        onHandleShare();
                      }}
                    />
                  </div>
                  <IonLabel className="discount_date offer_date">
                    <span className="date referal_left">
                      {props.referalDetails[0].referralsRemaining} of{" "}
                      {props.referalDetails[0].referralsRemaining +
                        props.referalDetails[0].referralsUsed}{" "}
                      referrals left
                    </span>
                  </IonLabel>
                </IonCol>
                <IonCol className="image_panel" size-md="6" size="5">
                  <div className="img_scroll">
                    <IonImg
                      src="/images/offer_icon.svg"
                      // className="discount_slides"
                      className="refer_earn_slide"
                    />
                  </div>
                </IonCol>
              </IonRow>
            </div>
          </div>
        )} */}

				<>
					{Boolean(ExpiredOffers.length > 0) && (
						<div className="refer_earn">
							<IonLabel>{constants.EXPIRED_OFFERS}</IonLabel>
						</div>
					)}
					{ExpiredOffers.length > 0 ? (
						Boolean(ExpiredOffers.length) &&
						ExpiredOffers.map((expireOffer: any, ind: any) => (
							<div
								className="offer_layout expired"
								style={{
									// background: `linear-gradient(93.91deg, ${expireOffer.displayColor} 1.09%, #231b05 64.95%)`,
									background: "#999999",
								}}
								onClick={() =>
									props.history.push({
										pathname: "/portal/offer-details",
										state: { offerDetails: expireOffer, isExpired: true },
									})
								}
							>
								<IonRow className="discount_row">
									{!!expireOffer.name && (
										<>
											<IonCol className="vocher_code expired_offer" size-md="6" size="7">
												<div
													className="discount_div"
													style={{
														width: "100%",
													}}
												>
													{/* <IonLabel className="discount_percentage" color="secondary">
                  {constants.FLAT} <span className="discount_value">20%</span>{" "}
                  {constants.DISCOUNT}
                </IonLabel> */}
													{/* <div
                      className="apply_white_color"
                      dangerouslySetInnerHTML={{
                        __html: expireOffer.displayTitle,
                      }}
                    /> */}
													<div className="discount_div discount_web offer_web">
														{expireOffer.name.split(" ").map((name: any, index: any) => (
															<IonLabel
																className={
																	index === 1 ? "discount_value" : "discount_percentage"
																}
																key={index}
															>
																{index === 2 ? "Discount" : name}
															</IonLabel>
														))}
													</div>
												</div>
												<div className="refer-and-earn expired_border">
													<IonLabel className="year use_code">
														{constants.USE_CODE}
														<span className="offer_flat_code">
															{expireOffer.offerCode}
														</span>
													</IonLabel>
												</div>
												<IonLabel className="discount_date">
													{constants.VALID}
													<span className="date">
														{moment(expireOffer.validity.endDate).format("DD MMM YYYY")}
													</span>
												</IonLabel>
											</IonCol>
											<IonCol className="image_panel" size-md="6" size="5">
												<div className="img_scroll">
													<IonImg
														// src="/images/offer_icon.svg"
														src={expireOffer.imageUrl}
														className="discount_slides"
													/>
												</div>
											</IonCol>
										</>
									)}

									{!expireOffer.name && (
										<IonCol className="image_panel" size-md="12" size="12">
											<div className="img_scroll">
												<IonImg src={expireOffer.imageUrl} />
											</div>
										</IonCol>
									)}
								</IonRow>
							</div>
						))
					) : (
						<ScreenBanner />
					)}
				</>

				{/* <div className="offer_layout save_discount expired mg-bottom">
        <IonRow className="discount_row">
          <IonCol className="vocher_code" size-md="6" size="7">
            <div className="discount_div">
              <IonLabel className="discount_percentage" color="secondary">
                {constants.SAVE_UP_TO}{" "}
                <span className="discount_value">30%</span>{" "}
              </IonLabel>
            </div>
            <div className="maintance">
              <IonLabel>On Periodic Car Maintenance</IonLabel>
            </div>
            <div className="learn_more">
              <IonLabel className="learn_more_text">
                {constants.LEARN_MORE}{" "}
              </IonLabel>
              <IonImg src="/images/learn_more.svg" />
            </div>
          </IonCol>
          <IonCol className="image_panel" size-md="6" size="5">
            <div className="img_scroll">
              <IonImg src="/images/save_upto.svg" className="discount_slides" />
            </div>
          </IonCol>
        </IonRow>
      </div> */}
			</div>
		</IonCol>
	);
};

export default connect(
	({ dashboard, userInfo: { referalDetails } }: any) => {
		const { offersData } = dashboard;
		return { offersData, referalDetails };
	},
	{ getOffersData }
)(Offers);